// PUBLIC ROUTES
export const CUSTOMER_SELF_MANAGEMENT = '/autogestion'
export const CUSTOMER_SELF_MANAGEMENT_CLIENTS = '/clientes'
export const CUSTOMER_SELF_MANAGEMENT_DOCUMENTS = '/documentos'
export const CUSTOMER_SELF_MANAGEMENT_ACCIDENTS = '/siniestros'
export const CUSTOMER_SELF_MANAGEMENT_ACCIDENTS_DETAIL = '/siniestros/:id'
export const CUSTOMER_SELF_MANAGEMENT_CHANGE_PAYMENT_METHOD = '/pagos'
export const CUSTOMER_SELF_MANAGEMENT_MODIFY_POLICY_DATA = '/datos'
export const CUSTOMER_SELF_MANAGEMENT_INSPECTIONS = '/inspecciones/:id'
export const CUSTOMER_SELF_MANAGEMENT_PAYMENT_REJECTIONS = '/rechazos'
export const MARKETING_UNSUBSCRIBE = '/marketing/unsubscribe'

// PRIVATE ROUTES
export const CLIENTS = '/clientes'
export const CLIENT_CREATION = `${CLIENTS}/nuevo`
export const CLIENT_DETAIL = `${CLIENTS}/:id`
export const COMMERCIAL_CONDITIONS = '/comerciales'
export const COMMERCIAL_CONDITIONS_DETAIL = '/comerciales/detalle'
export const COMMERCIAL_CONDITIONS_DETAIL_COVERAGE = '/comerciales/detalle/cobertura'
export const COMUNICATIONS = '/comunicaciones'
export const COMUNICATION_DETAIL = '/comunicaciones/:id'
export const CURRENT_ACCOUNT = '/liquidaciones'
export const CURRENT_ACCOUNT_LIQUIDATION = `${CURRENT_ACCOUNT}/:id`
export const DASHBOARD = '/dashboard'
export const FORGOT_PASSWORD = '/registro/recuperar-contrasena'
export const LOGIN = '/login'
export const LOGOUT = '/logout'
export const NOTIFICATIONS = '/notificaciones'
export const POLICIES = '/polizas'
export const WITHHOLDINGS = '/retenciones'
export const POLICY_DETAIL = `${POLICIES}/:id`
export const POLICY_CREATE = `${POLICIES}/nueva`
export const POLICY_CREATE_INITIAL = '/polizas/nueva/datos'
export const POLICY_CREATE_CLIENT = '/polizas/nueva/cliente'
export const POLICY_CREATE_DATA = '/polizas/nueva/descripcion'
export const POLICY_CREATE_PAYMENT = '/polizas/nueva/pago'
export const POLICY_CREATE_ASSET = '/polizas/nueva/bien'
export const POLICY_MODIFY = '/polizas/:id/editar'
export const POLICY_MODIFY_INITIAL = '/polizas/:id/editar/datos'
export const POLICY_MODIFY_CLIENT = '/polizas/:id/editar/cliente'
export const POLICY_MODIFY_DATA = '/polizas/:id/editar/descripcion'
export const POLICY_MODIFY_PAYMENT = '/polizas/:id/editar/pago'
export const POLICY_MODIFY_ASSET = '/polizas/:id/editar/bien'
export const POLICY_ENDORSEMENTS = '/polizas/:id/endosos'
export const POLICY_ENDORSEMENT_DETAIL = '/polizas/:id/endosos/:amendmentId'
export const POLICY_ENDORSEMENTS_MODIFICATIONS = '/polizas/:id/endosos/:amendmentId/modificaciones'
export const POLICY_ENDORSEMENT_PETITION = '/polizas/:id/endosos/solicitud/:petitionId'
export const POLICY_ENDORSEMENT_PETITION_CREATION = '/polizas/:id/endosos/solicitud/crear'
export const PROFILE = '/perfil'
export const QUOTES = '/cotizaciones'
export const QUOTES_CREATION = `${QUOTES}/crear`
export const QUOTES_CREATION_DYNAMIC = `${QUOTES_CREATION}/:type`
export const QUOTES_LIST_DYNAMIC = `${QUOTES}/:id`
export const QUOTE_EMISSION = `${QUOTES}/:multiquoteId/emitir/:quoteId/coberturas/:coverageId`
export const QUOTES_CREATION_CAR = `${QUOTES_CREATION}/auto`
export const QUOTES_LIST_CLUSTER = `${QUOTES}/coberturas/:id`
export const QUOTES_CREATION_CAR_BRAND = `${QUOTES_CREATION_CAR}/marca`
export const QUOTES_CREATION_CAR_CLIENT = `${QUOTES_CREATION_CAR}/cliente`
export const QUOTES_CREATION_CAR_ROUTES = [QUOTES_CREATION_CAR]
export const QUOTES_CREATION_CAR_LOCATION = `${QUOTES_CREATION_CAR}/locacion`
export const QUOTES_CREATION_CAR_SUMMARY = `${QUOTES_CREATION_CAR}/resumen`
export const QUOTES_CREATION_CAR_VERSION = `${QUOTES_CREATION_CAR}/version`
export const QUOTES_CREATION_ERROR = `${QUOTES_CREATION_CAR}/error`
export const QUOTES_CREATION_MOTO = `${QUOTES_CREATION}/moto`
export const QUOTES_CREATION_MOTO_BRAND = `${QUOTES_CREATION_MOTO}/marca`
export const QUOTES_CREATION_MOTO_CLIENT = `${QUOTES_CREATION_MOTO}/cliente`
export const QUOTES_CREATION_MOTO_LOCATION = `${QUOTES_CREATION_MOTO}/locacion`
export const QUOTES_CREATION_MOTO_SUMMARY = `${QUOTES_CREATION_MOTO}/resumen`
export const QUOTES_CREATION_MOTO_VERSION = `${QUOTES_CREATION_MOTO}/version`
export const REGISTER = '/registro'
export const REGISTER_FULL = '/onboarding'
export const REGISTER_FULL_DOCUMENTS = '/onboarding/full/documentación'
export const REGISTER_FULL_TERMS = '/onboarding/full/términos'
export const REGISTER_HELP = '/contacto'
export const REGISTER_PROFESSIONAL = '/onboarding/matricula'
export const REGISTER_VALIDATE = `${REGISTER}/validación`
export const REGISTER_VERIFY = `${REGISTER}/verificación`
export const RESET_PASSWORD = '/registro/nueva-contrasena'
export const SETTINGS = '/configuración'
export const SUCCESSFUL_CREATION_CLIENT = `${CLIENTS}/:id/creado`
export const SUCCESSFUL_EDIT_CLIENT = `${CLIENTS}/:id/editado`
